<template>
  <div class="success-page">
    <!-- <Header :title="title" /> -->
    <div class="content">
      <img
        v-if="success"
        src="../../../assets/img/classify/right@2x.png"
        alt=""
      />
      <img v-else src="../../../assets/img/classify/right@2x (1).png" alt="" />
      <p class="price-row" :class="{ success }">
        <span>￥</span>
        <strong>{{ moneyItem.intNum }}</strong>
        <span>.{{ moneyItem.floatNum }}</span>
      </p>
      <p class="message">{{ title }}</p>
    </div>
    <div class="button-bar">
      <button @click="backHome" v-if="success">继续购买</button>
      <button @click="backHome" v-else>返回首页</button>
      <button @click="seeOrder">查看订单</button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      orderNo: "",
      payMoney: "0.00",
      success: true,
      title: "支付成功",
	  id:''
    };
  },
  methods: {
    back() {
      // this.$router.go(-1);
	  this.$route.push('/')
    },
    backHome() {
      this.$router.go(-2);
      setTimeout(() => {
        if (this.$route.name !== "home") {
          this.$router.replace("/");
        }
      }, 10);
    },
    seeOrder() {
      if (this.id) {
        this.$router.replace(`/my/orderDetial?id=${this.id}`);
      } else {
        this.$router.replace("/my/myorder");
      }
    },
  },
  components: {},
  created() {
    if (this.$route.query.success === undefined) {
      this.$toast("未找到支付信息");
      setTimeout(() => this.$router.back(), 800);
      return;
    }
    this.orderNo = this.$route.query.orderNo || "";
    this.payMoney = this.$route.query.payMoney || "0.00";
    this.success = this.$route.query.success;
	this.id = this.$route.query.id
    if (!this.success) {
      this.title = "支付失败";
    }
  },
  computed: {
    moneyItem() {
      let list = this.payMoney.toString().split(".");
      return {
        intNum: list[0] || "0",
        floatNum: list[1] || "00",
      };
    },
  },
};
</script>

<style scoped lang="less">
.success-page {
  min-height: 100vh;
  background: #fbfbfb;
  font-family: PingFangSC-Regular, PingFang SC;

  .content {
    text-align: center;
    background-color: #fff;
    overflow: hidden;

    & > img {
      width: 64px;
      height: 64px;
      margin-top: 30px;
      margin-bottom: 14px;
    }

    .price-row {
      color: #fd0212;

      &.success {
        color: #6dd400;
      }

      span {
        font-size: 20px;
      }

      strong {
        font-size: 24px;
      }
    }

    .message {
      font-size: 13px;
      color: #303133;
      margin-top: 6px;
      margin-bottom: 57px;
    }
  }

  .button-bar {
    margin-top: 20px;
    display: flex;
    padding: 0 14px;

    button {
      flex: 1;
      font-size: 18px;
      border: 1px solid #fd0212;
      border-radius: 4px;
      padding: 12px;
      background-color: unset;
      position: relative;

      &::after {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        left: 0;
        top: 0;
      }

      &:active::after {
        content: "";
      }

      &:first-child {
        color: #fd0212;
      }

      &:last-child {
        margin-left: 15px;
        color: white;
        background-color: #fd0212;
      }
    }
  }
}
</style>